import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Image} from 'antd-mobile';
import {goTo} from '@/utils';
// import {Collapse} from 'antd-mobile';
// import {ChevronUpIcon, ChevronDownIcon} from '@heroicons/react/24/outline';
const inProject = ['Recharge', 'Withdraw', 'Chat'];

const HomeFAQ = () => {
  const {t} = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(true);

  const faqQuestions = [
    {
      question: t('home.faq.safeQuestion'),
      answer: t('home.faq.safeAnswer'),
    },
    {
      question: t('home.faq.trustedQuestion'),
      answer: t('home.faq.trustedAnswer'),
    },
    {
      question: t('home.faq.mobileQuestion'),
      answer: t('home.faq.mobileAnswer'),
    },
    {
      question: t('home.faq.betQuestion'),
      answer: t('home.faq.betAnswer'),
    },
    {
      question: t('home.faq.liveQuestion'),
      answer: t('home.faq.liveAnswer'),
    },
    {
      question: t('home.faq.playQuestion'),
      answer: t('home.faq.playAnswer'),
    },
    {
      question: t('home.faq.safeIndiaQuestion'),
      answer: t('home.faq.safeIndiaAnswer'),
    },
    {
      question: t('home.faq.trustedSiteQuestion'),
      answer: t('home.faq.trustedSiteAnswer'),
    },
  ];

  const faqItems = [
    {
      section: t('home.faq.help'),
      items: [
        // 创建路由以及页面
        {title: 'Game Rules', link: 'rules'}, // 点击进入 对应 public/help/rules.html
        {title: 'Deposit', link: 'Recharge'}, // 跳转到充值页面
        {title: 'Withdrawal', link: 'Withdraw'}, // 跳转到提现页面
        {title: 'Support', link: 'Chat'}, //调整到chat页面
      ],
    },
    {
      section: t('home.faq.parimatch'),
      items: [
        // 这些页面都创建在pages/faq/rupiibet 文件夹下
        {title: 'Terms and Conditions', link: 'condition'}, //点击进入对应public/help/condition.html
        {title: 'Privacy Policy', link: 'privacy'}, // 点击进入对应public/help/privacy.html
        {title: 'Public Offers', link: 'offers'}, // 点击进入对应public/help/offers.html
        {title: 'AML/KYC Policy', link: 'aml_kyc_policy'}, // 点击进入对应public/help/aml-kyc-policy.html
        {title: 'For partners', link: 'for_partners'}, // 点击进入对应public/help/for-partners.html
      ],
    },
    {
      section: t('home.faq.info'),
      items: [
        {title: 'Responsible gambling', link: 'responsible_gambling'}, // 点击进入对应 public/help/responsible-gambling.html
        {title: 'Self-exclusion', link: 'self_exclusion_long'}, // 点击进入对应 public/help/self-exclusion-long.html
        {title: 'Dispute resolution', link: 'dispute_resolution_policy'}, // 点击进入对应 public/help/dispute-resolution-policy.html
        {
          title: 'Privacy & Management of Personal Data',
          link: 'personal_data_privacy', // 点击进入对应 public/help/personal-data-privacy.html
        },
      ],
    },
  ];

  const handleItemClick = (link: string) => {
    if (inProject.includes(link)) {
      goTo(link);
    } else {
      // 使用 window.location.href 替代 window.open
      window.location.href = `${process.env.PUBLIC_URL}/${link}.html`;
      // 或者使用 navigate
      // navigate(`/help/${link}.html`);
    }
  };

  return (
    <div className="bg-white rounded-lg overflow-hidden">
      <div className="flex flex-col p-5 gap-3 border-b border-gray-100">
        <div className="flex items-center justify-between ">
          <h2 className="font-inter text-[0.875rem] font-bold leading-[1.0625rem]">
            {t('home.faq.title')}
          </h2>
          <div onClick={() => setIsCollapsed(!isCollapsed)}>
            {' '}
            {isCollapsed ? (
              <Image
                src={require('@assets/icons/home/close.webp')}
                // style={[theme.icon.xxl]}
                className="w-3 h-3"
              />
            ) : (
              <Image
                src={require('@assets/icons/home/open.webp')}
                // style={[theme.icon.xxl]}
                className="w-3 h-3"
              />
              // <ChevronDownIcon className="w-5 h-5" />
              // <ChevronUpIcon className="w-5 h-5" />
            )}
          </div>
        </div>
        <>
          {!isCollapsed && (
            <>
              {faqQuestions.map((item, index) => (
                <div key={index} className="rounded-lg">
                  <div className="flex items-start gap-2 mb-2">
                    {/* <span className="text-gray-500">?</span> */}
                    <div className="font-inter text-t2 font-bold text-[0.875rem] leading-[1.0625rem]">
                      {item.question}
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    {/* <span className="text-yellow-500">😺</span> */}
                    <span className="font-inter text-t2 text-[0.75rem] leading-[0.9376rem]">
                      {item.answer}
                    </span>
                  </div>
                </div>
              ))}
            </>
          )}
        </>
      </div>
      <div className="px-5 py-5 border-b border-gray-100">
        <div className="grid grid-cols-2 gap-x-3 gap-y-6">
          {faqItems.map((section, index) => (
            <div
              key={index}
              className={`flex flex-col gap-2 ${
                index === faqItems.length - 1 && faqItems.length % 2 !== 0
                  ? 'col-span-2'
                  : ''
              }`}>
              <h3 className="font-inter text-t1 text-sm font-bold leading-[1.0625rem] text-decoration-skip-ink-none">
                {section.section}
              </h3>
              {section.items.map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className="font-inter text-xs font-medium leading-[0.9376rem] text-t2 hover:text-primary cursor-pointer  text-decoration-skip-ink-none"
                  onClick={() => handleItemClick(item.link)}>
                  {item.title}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeFAQ;
